import { buildSelectOptions } from 'components/Selects/BaseSelect/utils/baseSelect.utils';
import { getDeviceTypeString } from 'features/GlobalActions/features/ActionBuilder/utils/builder.utils';

export const operators = [
  { operator: '==', types: ['all'] },
  { operator: '!=', types: ['all'] },
  { operator: '>', types: ['float'] },
  { operator: '<', types: ['float'] },
  { operator: '>=', types: ['float'] },
  { operator: '<=', types: ['float'] },
];

export const buildDeviceSelectOptions = (devices = []) => {
  return devices.map((device) => ({
    value: device.node_id.toString(),
    label:
      (device.device_type !== 'Manual Road Closure' ? `${device.static_id} ` : '') + device.alias,
    device,
  }));
};

export const buildSystemSelectOptions = (deviceTypes = {}, devicesBySystemAndTypeMap) =>
  buildSelectOptions(
    Object.keys(deviceTypes || {}).filter(
      (type) => devicesBySystemAndTypeMap?.has(type) && type !== 'Exacq Vision',
    ),
  );

export const buildDeviceTypeSelectOptions = (
  deviceTypes = {},
  devicesBySystemAndTypeMap,
  systemType,
) =>
  buildSelectOptions(
    Object.keys(deviceTypes?.[systemType] || {}).filter((type) => {
      const devices = devicesBySystemAndTypeMap?.get(systemType)?.get(type) || [];
      return devices.length > 0;
    }),
    (type) => type.replace('_', ' '),
  );

export const buildDeviceSubTypeSelectOptions = (deviceTypes = {}, systemType, deviceType) => {
  return buildSelectOptions(Object.keys(deviceTypes?.[systemType]?.[deviceType] || {}));
};

export const buildDeviceSelectOptionsForDeviceType = (devices = [], deviceType) => {
  return buildDeviceSelectOptions(
    devices.filter((device) => getDeviceTypeString(device) === deviceType),
  );
};

export const buildDeviceValueSelectOptions = (valueMap = {}) => {
  return Object.keys(valueMap || {}).map((key) => ({
    value: key,
    label: valueMap[key].name,
    valueMapItem: valueMap[key],
  }));
};

export const buildDeviceOperationSelectOptions = (operators = [], typeOfKey) => {
  const filteredOperators = operators.filter(
    (operator) => operator.types.includes('all') || operator.types.includes(typeOfKey),
  );

  return filteredOperators.map((operationObject) => ({
    value: operationObject.operator,
    label: operationObject.operator,
    operationObject: operationObject,
  }));
};

export const buildDeviceCompareValueSelectOptions = (valueMap = {}, keyType) => {
  const filteredValues = Object.keys(valueMap).filter((key) => valueMap[key].units === keyType);
  return filteredValues.map((key) => ({
    value: key,
    label: valueMap[key].name,
    valueMapItem: valueMap[key],
  }));
};

export const hasDeviceSubTypeOptions = (deviceTypes = {}, systemType, deviceType) => {
  const deviceTypeKeys = Object.keys(deviceTypes?.[systemType]?.[deviceType] || {});
  return deviceTypeKeys.length > 0 && !deviceTypeKeys.includes('validDevices');
};

export const isSelectableDeviceType = (deviceTypes = {}, systemType, deviceType) => {
  const deviceTypeConfig = deviceTypes?.[systemType]?.[deviceType];
  if (!deviceTypeConfig) return false;

  const deviceTypeKeys = Object.keys(deviceTypeConfig || {});
  return deviceTypeKeys.length === 0 || deviceTypeKeys.includes('validDevices');
};
